import {inject, Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import { HttpClient } from '@angular/common/http';

import {
  API_REQUEST_STEP_DELETE_SAS,
  API_REQUEST_STEP_DOWNLOAD_SAS,
  API_REQUEST_STEP_SUBMIT,
  API_REQUEST_STEP_UPLOAD_SAS
} from '../../../../../config/urls';
import {UrlService} from '@shared/services/url.service';
import {RequestStepUpdateDto} from '@dto/requests/request-step-update.dto';
import {FlowAttachmentDownloadSasRequestDto, FlowAttachmentSasRequestDto} from '@dto/files/flow-attachment-sas-request.dto';
import {FlowAttachmentSasResponseDto} from '@dto/files/flow-attachment-sas-response.dto';

@Injectable({
  providedIn: 'root'
})
export class FileRequestService {
  private readonly http = inject(HttpClient);
  private readonly urlService = inject(UrlService);

  public submitStep(requestId: string, requestStepId: number): Observable<RequestStepUpdateDto> {
    const endpointUrl = this.urlService.buildUrl(API_REQUEST_STEP_SUBMIT, requestId, String(requestStepId));
    return this.http.post<RequestStepUpdateDto>(endpointUrl, {});
  }

  public requestUploadSas(
    requestId: string,
    requestStepId: number,
    payload: FlowAttachmentSasRequestDto
  ): Observable<FlowAttachmentSasResponseDto> {
    const endpointUrl = this.urlService.buildUrl(API_REQUEST_STEP_UPLOAD_SAS, requestId, String(requestStepId));
    return this.http.post<FlowAttachmentSasResponseDto>(endpointUrl, payload);
  }

  public requestDeleteSas(
    requestId: string,
    requestStepId: number,
    payload: FlowAttachmentSasRequestDto
  ): Observable<FlowAttachmentSasResponseDto> {
    const endpointUrl = this.urlService.buildUrl(API_REQUEST_STEP_DELETE_SAS, requestId, String(requestStepId));
    return this.http.post<FlowAttachmentSasResponseDto>(endpointUrl, payload);
  }

  public requestDownloadSas(
    requestId: string,
    requestStepId: number,
    payload: FlowAttachmentDownloadSasRequestDto
  ): Observable<FlowAttachmentSasResponseDto> {
    const endpointUrl = this.urlService.buildUrl(API_REQUEST_STEP_DOWNLOAD_SAS, requestId, String(requestStepId));
    return this.http.post<FlowAttachmentSasResponseDto>(endpointUrl, payload);
  }

}
